<template>
  <k-form-section
    v-if="$featureFlags.isEnabled('meetings-inbox-gcal-integration')"
    :column-span="1"
    legend="Description"
  >
    <k-form-field :required="false" :field-id="fieldId">
      <textarea
        :id="fieldId"
        class="form-control"
        rows="3"
        :value="modelValue"
        maxlength="2048"
        placeholder="Additional info for meeting description..."
        aria-label="Description"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <k-character-count :id="`${fieldId}-count`" :value-length="modelValue.length" :max-length="2048" />
    </k-form-field>
  </k-form-section>
</template>

<script>
import { KFormSection, KFormField, KCharacterCount } from '@base-components/forms';

export default {
  name: 'meeting-description-section',

  components: {
    KFormSection,
    KFormField,
    KCharacterCount,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: 'meeting-description',
    },
  },

  emits: ['update:modelValue'],
};
</script>
